import styles from './simple-mobile-preview.module.scss';
import Link from 'next/link';
import { Themes } from '@layouts/main-layout/themes.enum';
import { ReactSVG } from 'react-svg';
import React from 'react';
import { useTranslations } from 'next-intl';
import { INavPreviewCards, INavPreviewCol } from '@models/nav.interface';
type SimpleMobilePreviewProps = {
  theme: Themes;
  cards: INavPreviewCards[];
  onMenuClicked?: () => void;
};

const SimpleMobilePreview = ({ theme, cards, onMenuClicked }: SimpleMobilePreviewProps) => {
  const t = useTranslations();

  const themedClasses = (classes: string) => `${classes} ${styles[theme]}`;
  const arrowIconSrc = '/layout-images/header/icons/chevron-right.svg';

  return (
    <div className={themedClasses(styles.cards)}>
      {cards.map((card, cardIndex, array) => (
        <React.Fragment key={cardIndex}>
          <div className={styles.cards__default}>
            <Link 
              scroll={false} 
              href={card.href} 
              onClick={onMenuClicked}
              target={card.newTab ? '_blank' : '_self'} 
              rel={card.newTab ? 'noopener noreferrer' : ''}
            >
              <div className={styles.cards__wr}>
                <ReactSVG
                  style={{ maxWidth: '32px', maxHeight: '32px' }}
                  src={card.iconSrc}
                />
                <div className={styles.cards__title__wr}>
                  <h4 className={styles.cards__title}>{t(card.title)}</h4>
                  <div className={styles.cards__subtitle}>{t(card.subtitle)}</div>
                </div>
                <ReactSVG
                  style={{ maxWidth: '16px', maxHeight: '16px' }}
                  src={arrowIconSrc}
                />
              </div>
            </Link>
          </div>
          {cardIndex !== array.length - 1 && <hr className={styles.divider} />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default SimpleMobilePreview;
